import { AxiosError } from 'axios';
import { ConfigurationType } from 'web-library/models/DropDown';
import { GET_PROFILE_AMENDMENT_REQUEST_STATUSES_URL } from '../../constants/apiUrls';
import { GET_PROFILE_AMENDMENT_REQUEST_STATUSES_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================
interface Input {
  onSuccess?: (res: ConfigurationType[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

// =============================================================================
// Query
// =============================================================================

export const useGetProfileAmendmentRequestStatuses = ({ onError, onSuccess }: Input = {}) => {
  const getProfileAmendmentRequestStatuses = async () => {
    const res = await axiosClient.get<ConfigurationType[]>(
      GET_PROFILE_AMENDMENT_REQUEST_STATUSES_URL
    );
    return res.data;
  };

  return useCustomQuery(
    GET_PROFILE_AMENDMENT_REQUEST_STATUSES_QUERY_KEY,
    getProfileAmendmentRequestStatuses,
    {
      onSuccess,
      onError,
    }
  );
};
